import { Divider, Typography, useTheme } from "@mui/material";
import { ChevronRight } from "lucide-react";
import type { FC, ReactNode } from "react";
import { DeprecatedRow } from "web_myplann/Profile/Components/DeprecatedRow";
import { BLOOD_RED_MYPLANN } from "web_myplann/Utils/constants";

type Props = {
	label: string;
	rightSlot?: ReactNode;
	showChevron?: boolean;
	destructive?: boolean;
	disabled?: boolean;
	isLast?: boolean;
	onClick?: () => void;
};

export const SettingsRow: FC<Props> = ({
	label,
	rightSlot,
	showChevron = false,
	destructive = false,
	disabled = false,
	isLast = false,
	onClick,
}) => {
	const theme = useTheme();

	return (
		<>
			<DeprecatedRow disabled={disabled} onClick={onClick}>
				<Typography
					variant="deprecatedBody1"
					color={
						destructive ? BLOOD_RED_MYPLANN : theme.palette.deprecated.grey[700]
					}
				>
					{label}
				</Typography>
				{rightSlot}
				{showChevron && !rightSlot && (
					<ChevronRight
						size={theme.iconSize.sm}
						color={theme.palette.primary.main}
					/>
				)}
			</DeprecatedRow>
			{!isLast && (
				<Divider sx={{ borderColor: theme.palette.deprecated.grey[200] }} />
			)}
		</>
	);
};
